import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { actions } from '../../actions/windowActions';

export class WindowResizeListener extends Component {
    componentDidMount() {
        // Set an initial width
        this.props.actions.handleWindowResize(window.innerWidth);
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        this.props.actions.handleWindowResize(window.innerWidth);
    }

    render() {
        return null;
    }
}

WindowResizeListener.propTypes = {
    actions: PropTypes.object.isRequired
};

function mapDispatchTpProps(dispatch) {
    return {
        actions: bindActionCreators({...actions}, dispatch)
    };
}


export default connect(null, mapDispatchTpProps)(WindowResizeListener);
